<template>
  <div class="vuetable-filterbar col-md-12">
    <div class="form-group p-l mb-sm-1 mt-1 mb-md-2">
      <b-container fluid class="p-0">
        <!-- Linha de Inputs -->
        <!-- Linha de Inputs Compacta -->
        <b-row align-v="end" no-gutters>
          <b-col cols="12" md="2" style="padding: 0 5px" class="mb-1 mb-md-3 mb-md-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control rounded-lg"
                v-model="observacao"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Observacao</label
              >
            </div>
            <small v-if="showError" class="text-danger ml-1">Pelo menos um filtro é obrigatório</small>
          </b-col>
          <b-col cols="12" md="2" style="padding: 0 5px" class="mb-1 mb-md-3 mb-md-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control rounded-lg"
                v-model="num_carga"
                @keyup.enter="doFilter"
              />
              <label class="fl-label">N° Carga</label>
            </div>
            <small v-if="showError" class="text-danger ml-1">Pelo menos um filtro é obrigatório</small>
          </b-col>
          <b-col cols="12" md="2" style="padding: 0 5px" class="mb-1 mb-md-3 mb-md-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control rounded-lg"
                v-model="num_fiscal_cte"
                @keyup.enter="doFilter"
              />
              <label class="fl-label">CTE/RPSC</label>
            </div>
            <small v-if="showError" class="text-danger ml-1">Pelo menos um filtro é obrigatório</small>
          </b-col>
          <b-col cols="12" md="2" style="padding: 0 5px" class="mb-1 mb-md-3 mb-md-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control rounded-lg"
                v-model="num_nf"
                @keyup.enter="doFilter"
              />
              <label class="fl-label">N° NF</label>
            </div>
            <small v-if="showError" class="text-danger ml-1">Pelo menos um filtro é obrigatório</small>
          </b-col>
          <b-col cols="12" md="2" style="padding: 0 5px" class="mb-1 mb-md-3 mb-md-0">
            <div class="switch-filter-container d-flex align-items-center rounded-lg border-0 bg-white px-2">
              <b-form-checkbox v-model="consulta_completa" switch value="1" unchecked-value="2" class="m-0">
                <span class="text-muted small pr-1">Consulta longa</span>
                <span 
                  v-b-tooltip 
                  title="Se marcado trará NFS importadas há mais de 60 dias" 
                  placement="top"
                  class="info-tooltip-icon"
                >
                  <span class="info-icon-fallback" v-if="!hasFontAwesome">?</span>
                </span>
              </b-form-checkbox>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>

    <div class="form-group p-l">
      <b-container fluid class="p-0">
        <!-- Linha de Ações (Compacta e com Espaçamento de 10px) -->
        <b-row class="mt-1">
          <b-col
            cols="12"
            class="d-md-flex flex-wrap justify-content-md-end px-2"
          >
            <button
              type="button"
              class="btn btn-secondary rounded-lg px-3 py-1 shadow-sm mb-1 mb-md-2 btn-mobile-full"
              @click="onEditarObs(null, null, null)"
              :disabled="vuetableFilterButton"
            >
              Recebimento MDFE
            </button>
            <button
              type="button"
              class="btn btn-secondary rounded-lg px-3 py-1 shadow-sm mb-1 mb-md-2 ml-md-2 btn-mobile-full"
              @click="onChecaMdfe()"
              :disabled="vuetableFilterButton"
            >
              Checar volumes MDFE
            </button>
            <button
              type="button"
              class="btn btn-secondary rounded-lg px-3 py-1 shadow-sm mb-1 mb-md-2 ml-md-2 btn-mobile-full"
              @click="doFilter"
              :disabled="vuetableFilterButton"
            >
              Filtrar
            </button>
            <button
              type="button"
              class="btn btn-outline-secondary rounded-lg px-3 py-1 bg-white mb-2 ml-md-2 btn-mobile-full"
              @click="resetFilter"
              :disabled="vuetableFilterButton"
              style="color: #6c757d"
            >
              Limpar
            </button>
          </b-col>
        </b-row>
      </b-container>
      <MontagemCargaMdfe ref="montagemcargamdfe" />
      <MontagemCargaChecaMdfe ref="montagemcargachecamdfe" />
    </div>
  </div>
</template>

<script>
import MontagemCargaMdfe from "./MontagemCargaMdfe";
import MontagemCargaChecaMdfe from "./MontagemCargaChecaMdfe";

export default {
  name: "MontagemCargaFilterBar",
  components: {
    MontagemCargaMdfe,
    MontagemCargaChecaMdfe,
  },
  data() {
    return {
      num_carga: "",
      num_nf: "",
      num_fiscal_cte: "",
      observacao: "",
      data_filter: {},
      showError: false,
      consulta_completa: "2",
      hasFontAwesome: false,
    };
  },
  mounted() {
    this.hasFontAwesome = !!Array.from(document.styleSheets).some(
      (s) => s.href && s.href.includes("font-awesome")
    ) || !!document.querySelector('link[href*="font-awesome"]');
    this.consulta_completa = "2";
  },
  watch: {
    num_carga() { if (this.num_carga) this.showError = false; },
    num_nf() { if (this.num_nf) this.showError = false; },
    num_fiscal_cte() { if (this.num_fiscal_cte) this.showError = false; },
    observacao() { if (this.observacao) this.showError = false; }
  },
  methods: {
    doFilter() {
      if (
        !this.num_carga && 
        !this.num_nf && 
        !this.num_fiscal_cte && 
        !this.observacao
      ) {
        this.showError = true;
        return;
      }

      this.showError = false;
      this.$store.commit("setVuetableFilterButton", true);
      this.data_filter = {
        num_carga: this.num_carga,
        num_nf: this.num_nf,
        num_fiscal_cte: this.num_fiscal_cte,
        observacao: this.observacao,
        consulta_completa: this.consulta_completa,
      };
      this.$events.fire("filter-set", this.data_filter);
    },
    resetFilter() {
      this.num_carga = "";
      this.num_nf = "";
      this.num_fiscal_cte = "";
      this.observacao = "";
      this.consulta_completa = "2";
      this.showError = false;
      this.$events.fire("filter-reset");
    },
    onEditarObs() {
      this.$refs.montagemcargamdfe.onEdit();
    },
    onChecaMdfe() {
      this.$refs.montagemcargachecamdfe.onCreate();
    },
  },
  computed: {
    vuetableFilterButton: {
      get() {
        return this.$store.state.vuetable.filterButton;
      },
    },
  },
};
</script>

<style scoped>
.rounded-pill {
  border-radius: 50rem !important;
}
.rounded-lg {
  border-radius: 0.5rem !important;
}
.fl-label {
  left: 13px !important;
  right: 12px !important;
  pointer-events: none;
}
.btn-toolbar {
  align-items: center;
}
.m-t-5px {
  margin-top: 5px;
}
.ml-10px {
  margin-left: 10px !important;
}
@media (max-width: 767.98px) {
  .btn-mobile-full {
    width: 100% !important;
    margin-left: 0 !important;
  }
}
.switch-filter-container {
  height: 40px;
  background: #ffffff;
  border-color: #dee2e6 !important;
}
.info-tooltip-icon {
  font-size: 14px;
  cursor: help;
  display: inline-flex;
  align-items: center;
}
.info-icon-fallback {
  width: 16px;
  height: 16px;
  background: #6c757d;
  color: white;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: bold;
}
</style>
